export const environment = {
  production: true,
  API_URL: 'https://plataforma-transforma.com/api/',
  API_ASSETS_URL: '//api.web.fundak.io/public/'
};